import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const ConfirmationModal = ({ show, onClose, onDevice, body, isLoading }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Sending to Device</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isLoading}>
          No
        </Button>
        <Button variant="danger" onClick={onDevice} disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
            </>
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
